module.exports = __webpack_public_path__ + "img/category.2375c9a1.svg";